// import React, { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const SessionTimeout = ({ timeoutDuration = 2 * 60 * 1000, cacheDuration = 10 * 60 * 1000 }) => {
//   const [lastActivity, setLastActivity] = useState(Date.now());
//   const navigate = useNavigate();

//   // Save session data in localStorage
//   const saveToCache = useCallback(() => {
//     const appData = {
//       lastActivity: Date.now(),
//       userData: JSON.parse(localStorage.getItem("userData")) || {},
//     };
//     localStorage.setItem("appData", JSON.stringify(appData));
//   }, []);

//   // Restore session data from localStorage
//   const restoreFromCache = useCallback(() => {
//     const cachedData = JSON.parse(localStorage.getItem("appData"));
//     if (cachedData && Date.now() - cachedData.lastActivity < cacheDuration) {
//       console.log("Restoring data from cache:", cachedData.userData);
     
//     } else {
//       localStorage.removeItem("appData");
//       alert("Session expired. Please log in again.");
//       navigate("/"); 
//     }
//   }, [cacheDuration, navigate]);

//   // Handle user inactivity
//   const checkInactivity = useCallback(() => {
//     if (Date.now() - lastActivity > timeoutDuration) {
//       alert("Session timed out due to inactivity. Please log in again.");
//       saveToCache(); // Save data to cache before logging out
//       localStorage.clear();
//       navigate("/");
//     }
//   }, [lastActivity, timeoutDuration, navigate, saveToCache]);


//   const handleActivity = useCallback(() => {
//     setLastActivity(Date.now());
//     localStorage.setItem("lastActivity", Date.now());
//   }, []);

//   useEffect(() => {
//     window.addEventListener("mousemove", handleActivity);
//     window.addEventListener("keydown", handleActivity);
//     window.addEventListener("click", handleActivity);

//     return () => {
//       window.removeEventListener("mousemove", handleActivity);
//       window.removeEventListener("keydown", handleActivity);
//       window.removeEventListener("click", handleActivity);
//     };
//   }, [handleActivity]);

//   useEffect(() => {
//     const interval = setInterval(checkInactivity, 1000);
//     return () => clearInterval(interval);
//   }, [checkInactivity]);

//   // Restore from cache on component mount
//   useEffect(() => {
//     restoreFromCache();
//   }, [restoreFromCache]);

//   return null;
// };

// export default SessionTimeout;


import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const SessionTimeout = ({ timeout }) => {
  const navigate = useNavigate();

  const ins = typeof window !== "undefined" ? localStorage.getItem("institute") : null;
  useEffect(() => {
    const handleActivity = () => {
      localStorage.setItem("lastActivity", Date.now());
    };

    const checkSession = () => {
      const lastActivity = parseInt(localStorage.getItem("lastActivity"), 10);
      const now = Date.now();

      if (lastActivity && now - lastActivity > timeout) {
        alert("Session timed out. Please log in again.");
        localStorage.clear();
        navigate(`/${ins}`); 
      }
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("click", handleActivity);
    handleActivity();
    const interval = setInterval(checkSession, 1000);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("click", handleActivity);
      clearInterval(interval);
    };
  }, [navigate, timeout]);

  return null; 
};

export default SessionTimeout;
